export default __webpack_public_path__ + "static/media/barbarian_color.39841731.png";